"use client";

import { AccountStateGate } from "@/components/AccountStateGate";
import { OnboardingRouter } from "@/components/OnboardingRouter";
import ProtectedSidebarLayout from "@/components/protected-sidebar-layout";
import SplashScreen from "@/components/splash-screen";
import {
  CustomerAccountProvider,
  OtpProvider,
  useCustomerAccount,
} from "@/providers";
import { TickerProvider } from "@/providers/TickerProvider";

function CustomerAccountLayoutInner({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isSwitchingAccount, switchingAccountName } = useCustomerAccount();

  return (
    <AccountStateGate>
      <TickerProvider>
        <OtpProvider>
          <SplashScreen
            isSwitchingAccount={isSwitchingAccount}
            switchingAccountName={switchingAccountName}
          >
            <ProtectedSidebarLayout>{children}</ProtectedSidebarLayout>
          </SplashScreen>
        </OtpProvider>
      </TickerProvider>
    </AccountStateGate>
  );
}

export default function CustomerAccountLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <OnboardingRouter>
      <CustomerAccountProvider>
        <CustomerAccountLayoutInner>{children}</CustomerAccountLayoutInner>
      </CustomerAccountProvider>
    </OnboardingRouter>
  );
}
